export const LogoMark = ({ className = "h-9 w-9 text-ink" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="17.5" stroke="currentColor" strokeWidth="3" />
    <path
      d="M24 13c5.2 6.1 8 9.3 8 13.6a8 8 0 1 1-16 0C16 22.3 18.8 19.1 24 13z"
      fill="#C86A51"
    />
  </svg>
);

export default function Logo({ dark = false }) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 ${dark ? "text-parchment" : "text-ink"}`}
      data-testid="brand-logo"
    >
      <LogoMark />
      <span className="font-display text-[26px] leading-none tracking-tight">
        Knot <em className="font-light italic">&amp;</em> Cast
      </span>
    </span>
  );
}
